export function getVideoViews(video = {}) {
    const resolve = (value) => {
        if (!value || typeof value !== 'string') return '';
        if (/^https?:\/\//i.test(value)) return value;
        const base = (process.env.REACT_APP_VIDEO_URL || '').replace(/\/+$/, '');
        const relative = value.replace(/^\/+/, '');
        return base ? `${base}/${relative}` : relative;
    };
    const rear = resolve(video.rearVideoUrl || video.videoUrl);
    const front = resolve(video.frontVideoUrl);
    if (rear && front && rear !== front) {
        return [{ id: 'rear', label: 'Rear camera', url: rear },
            { id: 'front', label: 'Front camera', url: front }];
    }
    const url = resolve(video.videoUrl) || rear || front;
    return url ? [{ id: 'single', label: 'Video', url }] : [];
}
